module.exports = __webpack_public_path__ + "24c5659b.svg";